import React from 'react';
import styled, { css } from 'styled-components';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

const colorMixin = (props, type) => {
  let color;
  switch (type) {
    case 'success':
      color = p4Tokens.statusFlagSuccess;
      break;
    case 'warning':
      color = p4Tokens.statusFlagWarning;
      break;
    case 'info':
      color = p4Tokens.statusFlagInfo;
      break;
    case 'danger':
      color = p4Tokens.statusFlagDanger;
      break;
    default:
      color = p4Tokens.statusFlagBasic;
  }

  return css`
    border: 1px solid ${color};
    background-color: ${color};
  `;
};

const sizeMixin = ({ small, large }: { small?: boolean; large?: boolean }) => {
  if (!small && !large) {
    return css`
      padding: 2px 5px;
      font-size: 12px;
    `;
  }

  if (small) {
    return css`
      padding: 1px 3px;
      font-size: 10px;
    `;
  }

  return css`
    padding: 4px 10px;
    font-size: 14px;
  `;
};

const pillMixin = (props) => {
  return css`
    border-radius: 3px;
    color: white;
    display: ${(props) => (props.inline ? 'inline' : 'block')};
    font-weight: bold;
    line-height: 99%;
    margin: 0;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
  `;
};

export const DefaultPill = styled.div<{ style: React.CSSProperties }>`
  ${pillMixin} ${sizeMixin} ${(props) => colorMixin(props, 'default')};
`;

export const SuccessPill = styled.div<{ style: React.CSSProperties }>`
  ${pillMixin} ${sizeMixin} ${(props) => colorMixin(props, 'success')};
`;

export const WarningPill = styled.div<{ style: React.CSSProperties }>`
  ${pillMixin} ${sizeMixin} ${(props) => colorMixin(props, 'warning')};
`;

export const DangerPill = styled.div<{ style: React.CSSProperties }>`
  ${pillMixin} ${sizeMixin} ${(props) => colorMixin(props, 'danger')};
`;

export const InfoPill = styled.div<{ style: React.CSSProperties }>`
  ${pillMixin} ${sizeMixin} ${(props) => colorMixin(props, 'info')};
`;

export const LuckinsTag = () => (
  <>
    <span style={{ color: '#EF3E33' }}>{'LUCKINS'}</span>
    <span style={{ color: '#1B3668' }}>{'live'}</span>
  </>
);

export const LuckinsPill = () => (
  <DefaultPill style={{ textTransform: 'none', border: '1px solid white', backgroundColor: 'white' }}>
    <LuckinsTag />
  </DefaultPill>
);
